import { Card, CardContent, CircularProgress } from "@mui/material";
import { snack } from "components/Snack/Snack";
import { toCurrencyFormat } from "helpers/utils";
import { useEffect, useState } from "react";
import { MdChat, MdPayments } from "react-icons/md";
import paymentsService from "services/admin/paymentsService";
import agentsService from "services/admin/AgentsService";
import withRouter from "hoc/withRouter";
import { FaPercentage } from "react-icons/fa";

const AgentStatsConversionRate = ({ router: { params }, month }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(0)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadData()
  }, [month])

  async function loadData() {
    try {
      setLoading(true)
      const { data: result } = await agentsService.getLeadConversionRate({ month })
      console.log(`AgentStatsDialogs:`, result);
      setData(result.rate)
    } catch (ex) {
      console.error(`AgentStatsDialogs ex: `, ex)
      snack(ex?.message)
      setError(ex?.message)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="text-center"><CircularProgress></CircularProgress></div>
  }

  if (error) {
    return <div>{error}</div>
  }

  return (
    <Card style={{ backgroundColor: 'var(--card-background-color)' }} className="stat-card">
      <CardContent>
        <div className="text-center flex flex-col items-center justify-center">
          <FaPercentage size="42" style={{ color: 'rgba(83, 155, 255)' }}></FaPercentage>
          <h5 className="text-info">Конверсия(%)</h5>
          <h5 className="text-info mt-1">{data}%</h5>
        </div>
      </CardContent>
    </Card>
  );
};

export default withRouter(AgentStatsConversionRate)
